import { createContext } from 'react';

interface ITableContext {
  loading: boolean;
}

export const TableContext = createContext({} as ITableContext);
